(function () {
  const CREATE_SITE_SELECTOR = 'a[href*="id.discourse.com/create-site"]';
  const COOKIE_NAMES = { coupon_code: "coupon", referral_code: "referral" };

  const cookies = document.cookie.split(";");
  const params = {};

  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].trim().split("=");
    const name = parts[0];
    const value = parts.slice(1).join("=");
    if (COOKIE_NAMES[name] && value) {
      params[COOKIE_NAMES[name]] = decodeURIComponent(value);
    }
  }

  if (Object.keys(params).length === 0) {
    return;
  }

  const links = document.querySelectorAll(CREATE_SITE_SELECTOR);
  for (let j = 0; j < links.length; j++) {
    const url = new URL(links[j].href);
    for (const key in params) {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, params[key]);
      }
    }
    links[j].href = url.toString();
  }
})();
